import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initStaleBundleReload } from "./lib/stale-bundle";
import { initVersionPolling } from "./lib/version-banner";

initStaleBundleReload();
initVersionPolling();
createRoot(document.getElementById("root")!).render(<App />);
